import { InvitationScreen } from '@avrahami/ui';
import { Link } from '@tanstack/react-router';
import { invitationApi } from '../api/session';
import { he } from '../i18n/he';
import { errorMessage } from '../lib/forms';

/** Public page behind an invitation link: a store owner or staff member sets a first password. */
export function InvitationPage() {
  return (
    <InvitationScreen
      product={he.app.product}
      words={he.invitation}
      inspect={invitationApi.inspect}
      accept={invitationApi.accept}
      errorText={errorMessage}
      loginLink={
        <Link to="/login" search={{}} className="text-center text-brand-700 underline">
          {he.invitation.goToLogin}
        </Link>
      }
    />
  );
}
